import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SpashNotifComponent } from './components/spash-notif/spash-notif.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AlertSimpleComponent } from './components/alert-simple/alert-simple.component';
import { ToggleNotifComponent } from './components/toggle-notif/toggle-notif.component';
import { TranslateModule } from '@ngx-translate/core';
import { SwissDatePipeModule } from '@lcms/shared/helpers';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { QuestionNotifComponent } from './components/question-notif/question-notif.component';
import {SharedDataAccessUserModule} from "@lcms/shared/data-access-user";

@NgModule({
    imports: [
        CommonModule,
        SweetAlert2Module.forRoot(),
        InlineSVGModule,
        TranslateModule,
        SwissDatePipeModule,
        NgxShimmerLoadingModule,
        SharedDataAccessUserModule,
    ],
  exports: [SpashNotifComponent, AlertSimpleComponent, ToggleNotifComponent, QuestionNotifComponent],
  declarations: [
    SpashNotifComponent,
    AlertSimpleComponent,
    ToggleNotifComponent,
    QuestionNotifComponent,
  ],
})
export class SharedNotifificationsModule {}
